export default __webpack_public_path__ + "static/Plots0016-28cfc9a9c46422d0ade56e10625de891.jpg";